/* ============================================================
   Home Novelties — global theme JS
   Scroll reveals, parallax hero, theme switcher, toast,
   wishlist hearts, style quiz, newsletter popup.
   (Cart/AJAX logic lives in cart.js)
   ============================================================ */
(function () {
  'use strict';

  /* ── SCROLL ANIMATIONS ── */
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) entry.target.classList.add('visible');
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

  function observeReveals(root) {
    (root || document).querySelectorAll('.reveal, .reveal-left, .reveal-right, .reveal-scale')
      .forEach(function (el) { observer.observe(el); });
  }
  observeReveals(document);
  window.HNobserveReveals = observeReveals;

  setTimeout(function () {
    document.querySelectorAll('.hero .reveal').forEach(function (el) { el.classList.add('visible'); });
  }, 100);

  /* ── HERO SCROLL ANIMATION (parallax drift + zoom, content fade + lift) ── */
  var heroSection = document.getElementById('hero-section');
  var ticking = false;
  function runHeroScroll() {
    var scrolled = window.scrollY;
    var h = heroSection ? heroSection.offsetHeight : window.innerHeight;
    if (scrolled <= h + 60) {
      var progress = h > 0 ? Math.min(scrolled / h, 1) : 0;
      // Background: parallax drift down + gentle zoom in
      var ty = scrolled * 0.32;
      var scale = (1 + progress * 0.14).toFixed(4);
      var bgs = document.querySelectorAll('#hero-img, #hero-video, .hero-layer-video');
      for (var i = 0; i < bgs.length; i++) {
        bgs[i].style.transform = 'translateY(' + ty.toFixed(1) + 'px) scale(' + scale + ')';
      }
      // Content: fade out + lift as the hero scrolls away
      var op = Math.max(0, 1 - progress * 1.35).toFixed(3);
      var cty = (progress * -64).toFixed(1);
      var contents = document.querySelectorAll('.hero .hero-content');
      for (var j = 0; j < contents.length; j++) {
        contents[j].style.opacity = op;
        contents[j].style.transform = 'translateY(' + cty + 'px)';
        contents[j].style.willChange = 'opacity, transform';
      }
    }
    ticking = false;
  }
  if (heroSection) {
    window.addEventListener('scroll', function () {
      if (reduceMotion) return;
      if (!ticking) { requestAnimationFrame(runHeroScroll); ticking = true; }
    }, { passive: true });
    window.addEventListener('resize', function () { if (!reduceMotion) runHeroScroll(); }, { passive: true });
  }

  /* ── SCROLL-PLAY VIDEOS ──
     Any <video data-scroll-play> auto-plays when scrolled into view and
     pauses when it leaves, so background videos only run while visible. */
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var videoObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var v = entry.target;
      if (entry.isIntersecting && !reduceMotion) {
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      } else {
        v.pause();
      }
    });
  }, { threshold: 0.2 });

  function observeScrollVideos(root) {
    (root || document).querySelectorAll('video[data-scroll-play]').forEach(function (v) {
      v.muted = true;
      v.setAttribute('playsinline', '');
      if (!v.getAttribute('preload')) v.preload = 'metadata';
      videoObserver.observe(v);
    });
  }
  observeScrollVideos(document);
  window.HNobserveScrollVideos = observeScrollVideos;

  /* ── GENERALIZED PARALLAX ──
     Elements with [data-parallax="0.2"] drift on scroll (factor = strength).
     Their parent should be overflow:hidden and the element sized >100% so the
     drift never reveals an edge (handled in CSS for parallax media). */
  var parallaxEls = [];
  function collectParallax() {
    parallaxEls = Array.prototype.slice.call(document.querySelectorAll('[data-parallax]'));
  }
  function runParallax() {
    var vh = window.innerHeight;
    for (var i = 0; i < parallaxEls.length; i++) {
      var el = parallaxEls[i];
      var rect = el.getBoundingClientRect();
      if (rect.bottom < -200 || rect.top > vh + 200) continue;
      var speed = parseFloat(el.getAttribute('data-parallax')) || 0.18;
      var offset = (rect.top + rect.height / 2 - vh / 2) * -speed;
      el.style.transform = 'translate3d(0,' + offset.toFixed(1) + 'px,0)';
    }
    pTicking = false;
  }
  var pTicking = false;
  if (!reduceMotion) {
    collectParallax();
    window.addEventListener('scroll', function () {
      if (!pTicking) { requestAnimationFrame(runParallax); pTicking = true; }
    }, { passive: true });
    window.addEventListener('resize', function () { collectParallax(); runParallax(); }, { passive: true });
    runParallax();
  }
  window.HNrefreshParallax = function () { collectParallax(); runParallax(); };

  /* ── HERO THEME SWITCHER ── */
  window.switchHero = function (theme) {
    var themes = ['default', 'cottagecore', 'coastal', 'animals'];
    var target = theme || 'default';
    themes.forEach(function (id) {
      var el = document.getElementById('hero-' + id);
      if (el) el.classList.toggle('active', id === target);
    });
  };

  /* ── HEADER SHADOW ON SCROLL ── */
  var header = document.getElementById('site-header');
  if (header) {
    window.addEventListener('scroll', function () {
      header.classList.toggle('scrolled', window.scrollY > 20);
    }, { passive: true });
  }

  /* ── TOAST ── */
  var toastTimer;
  window.showToast = function (msg) {
    var toast = document.getElementById('toast');
    if (!toast) return;
    document.getElementById('toast-msg').textContent = msg;
    toast.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.classList.remove('show'); }, 2400);
  };

  /* ── WISHLIST (localStorage — Shopify has no native wishlist) ──
     Stores an array of product objects keyed by handle so the
     wishlist page can render without preloading the catalog. */
  var WKEY = 'hn_wishlist';
  function getWishlist() { try { return JSON.parse(localStorage.getItem(WKEY) || '[]'); } catch (e) { return []; } }
  function setWishlist(list) { localStorage.setItem(WKEY, JSON.stringify(list)); }
  function inWishlist(handle) { return getWishlist().some(function (p) { return p.handle === handle; }); }
  window.HNWishlist = { get: getWishlist, set: setWishlist, has: inWishlist };

  window.toggleHeart = function (btn) {
    var svg = btn.querySelector('svg');
    var on = svg.getAttribute('fill') === '#C44D2E';
    svg.setAttribute('fill', on ? 'none' : '#C44D2E');
    svg.setAttribute('stroke', on ? '#9EB0AF' : '#C44D2E');
    btn.style.background = on ? 'white' : '#FFF0EE';

    var handle = btn.getAttribute('data-handle');
    if (handle) {
      var list = getWishlist();
      if (on) {
        list = list.filter(function (p) { return p.handle !== handle; });
      } else if (!inWishlist(handle)) {
        list.push({
          handle: handle,
          title: btn.getAttribute('data-title') || '',
          url: btn.getAttribute('data-url') || ('/products/' + handle),
          image: btn.getAttribute('data-image') || '',
          price: btn.getAttribute('data-price') || '',
          vendor: btn.getAttribute('data-vendor') || ''
        });
      }
      setWishlist(list);
      document.dispatchEvent(new CustomEvent('wishlist:updated'));
    }
    if (!on) window.showToast('Saved to wishlist ♡');
  };

  window.toggleWish = function (btn) {
    var svg = document.getElementById('wish-icon');
    if (!svg) return;
    var on = svg.getAttribute('fill') === '#C44D2E';
    svg.setAttribute('fill', on ? 'none' : '#C44D2E');
    svg.setAttribute('stroke', on ? 'currentColor' : '#C44D2E');
    btn.style.color = on ? '' : '#C44D2E';
  };

  // Reflect saved wishlist state on load
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.heart-btn[data-handle]').forEach(function (btn) {
      if (inWishlist(btn.getAttribute('data-handle'))) {
        var svg = btn.querySelector('svg');
        svg.setAttribute('fill', '#C44D2E');
        svg.setAttribute('stroke', '#C44D2E');
        btn.style.background = '#FFF0EE';
      }
    });
  });

  /* ── MOBILE MENU ── */
  window.toggleMobileMenu = function () {
    var m = document.getElementById('mobile-menu');
    if (m) m.classList.toggle('open');
  };

  /* ── NEWSLETTER (inline section form fake-submit, popup handled below) ── */
  window.handleSubscribe = function (e) {
    e.preventDefault();
    var btn = e.target.querySelector('button');
    btn.textContent = "✓ You're in!";
    btn.style.background = 'var(--color-primary-dark)';
    var input = e.target.querySelector('input');
    if (input) input.value = '';
    window.showToast('Welcome! Check your inbox for 10% off.');
    setTimeout(function () { btn.textContent = 'Subscribe →'; btn.style.background = ''; }, 4000);
  };

  /* ── THEME QUIZ ── */
  var THEMES = {
    cottagecore: { name: 'English Cottagecore', subtitle: 'Country Charm', url: '/collections/english-cottagecore',
      img: 'https://picsum.photos/seed/english-garden-cottage-warm-2025/800/450',
      desc: 'Soft florals, vintage charm, and the warmth of an English garden brought indoors. You crave a home that feels lived-in, romantic, and full of character.' },
    coastal: { name: 'American Coastal', subtitle: 'Driftwood Living', url: '/collections/american-coastal',
      img: 'https://picsum.photos/seed/coastal-ocean-beach-home-2025/800/450',
      desc: 'Airy whites, driftwood textures, and the breezy calm of a seaside retreat. Your ideal home is light, fresh, and effortlessly relaxed.' },
    animals: { name: 'Animal Lovers', subtitle: 'Paws & Wings', url: '/collections/animal-lovers',
      img: 'https://picsum.photos/seed/nature-wildlife-cozy-home-2025/800/450',
      desc: 'Wild prints, earthy warmth, and nature-inspired art for those who love the animal kingdom. Your home tells a story of the wild.' }
  };
  var QUESTIONS = [
    { q: "What's your dream weekend escape?", answers: [
      { text: 'A countryside cottage with a blooming flower garden', theme: 'cottagecore' },
      { text: 'A sunlit beach house with ocean views', theme: 'coastal' },
      { text: 'A forest cabin surrounded by wildlife', theme: 'animals' } ] },
    { q: 'Which color palette feels most like home?', answers: [
      { text: 'Blush pinks, sage greens & warm ivory', theme: 'cottagecore' },
      { text: 'Navy blues, sandy beige & crisp white', theme: 'coastal' },
      { text: 'Earthy browns, warm amber & forest green', theme: 'animals' } ] },
    { q: 'Which texture speaks to you most?', answers: [
      { text: 'Soft linen, delicate florals & wicker', theme: 'cottagecore' },
      { text: 'Seagrass, weathered teak & rope details', theme: 'coastal' },
      { text: 'Rich velvet, faux fur & leather grain', theme: 'animals' } ] },
    { q: 'How would you describe your ideal room?', answers: [
      { text: 'Romantic & vintage — full of charm and character', theme: 'cottagecore' },
      { text: 'Bright & breezy — clean, open, and calming', theme: 'coastal' },
      { text: 'Bold & earthy — nature-inspired with personality', theme: 'animals' } ] },
    { q: 'Which scent best fits your dream home?', answers: [
      { text: 'Fresh lavender and rose petals', theme: 'cottagecore' },
      { text: 'Sea salt and sun-dried linen', theme: 'coastal' },
      { text: 'Cedarwood and pine forest', theme: 'animals' } ] }
  ];

  function shuffle(arr) {
    var a = arr.slice();
    for (var i = a.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = a[i]; a[i] = a[j]; a[j] = t;
    }
    return a;
  }

  var currentQ = 0, scores = {}, shuffled = [];

  function renderQuestion() {
    var q = shuffled[currentQ];
    var total = QUESTIONS.length;
    document.getElementById('tq-progress').style.width = ((currentQ / total) * 100) + '%';
    document.getElementById('tq-meta').textContent = 'Question ' + (currentQ + 1) + ' of ' + total;
    document.getElementById('tq-question-text').textContent = q.q;
    var container = document.getElementById('tq-answers');
    container.innerHTML = '';
    q.answers.forEach(function (a) {
      var btn = document.createElement('button');
      btn.className = 'tq-answer';
      btn.textContent = a.text;
      btn.addEventListener('click', function () { selectAnswer(btn, a.theme); });
      container.appendChild(btn);
    });
  }

  function selectAnswer(btn, theme) {
    if (document.getElementById('tq-answers').querySelector('.selected')) return;
    btn.classList.add('selected');
    scores[theme] = (scores[theme] || 0) + 1;
    setTimeout(function () {
      currentQ++;
      if (currentQ < QUESTIONS.length) renderQuestion();
      else showResult();
    }, 460);
  }

  function showResult() {
    var winner = Object.keys(scores).sort(function (a, b) { return scores[b] - scores[a]; })[0];
    var t = THEMES[winner];
    document.getElementById('tq-progress').style.width = '100%';
    document.getElementById('tq-question-screen').classList.add('hide');
    var result = document.getElementById('tq-result');
    result.innerHTML =
      '<p class="tq-result-eyebrow">Your style match</p>' +
      '<p class="tq-result-headline">Your home deserves the ' + t.name + ' look.</p>' +
      '<div class="tq-result-card" onclick="location.href=\'' + t.url + '\'">' +
        '<img src="' + t.img + '" alt="' + t.name + '" loading="lazy">' +
        '<div class="tq-result-card-overlay"></div>' +
        '<div class="tq-result-card-info">' +
          '<p class="tq-result-card-tag">' + t.subtitle + '</p>' +
          '<p class="tq-result-card-name">' + t.name + '</p>' +
          '<p class="tq-result-card-sub">' + t.desc + '</p>' +
        '</div>' +
      '</div>' +
      '<div class="tq-result-actions">' +
        '<a href="' + t.url + '" class="tq-result-cta">Shop ' + t.name + ' →</a>' +
        '<button class="tq-retake" onclick="window._tqRetake()">Retake quiz</button>' +
      '</div>';
    result.classList.add('show');
    document.querySelector('.tq-modal').scrollTop = 0;
  }

  function resetQuiz() {
    currentQ = 0;
    scores = {};
    Object.keys(THEMES).forEach(function (k) { scores[k] = 0; });
    shuffled = QUESTIONS.map(function (q) { return { q: q.q, answers: shuffle(q.answers) }; });
  }

  window.openThemeQuiz = function () {
    if (!document.getElementById('tq-overlay')) return;
    resetQuiz();
    var overlay = document.getElementById('tq-overlay');
    overlay.style.display = 'flex';
    requestAnimationFrame(function () { requestAnimationFrame(function () { overlay.classList.add('open'); }); });
    document.getElementById('tq-question-screen').classList.remove('hide');
    document.getElementById('tq-result').classList.remove('show');
    renderQuestion();
  };

  window._tqRetake = function () {
    resetQuiz();
    document.getElementById('tq-question-screen').classList.remove('hide');
    document.getElementById('tq-result').classList.remove('show');
    renderQuestion();
  };

  document.addEventListener('DOMContentLoaded', function () {
    var overlay = document.getElementById('tq-overlay');
    if (overlay) {
      function closeQuiz() {
        overlay.classList.remove('open');
        setTimeout(function () { overlay.style.display = 'none'; }, 300);
      }
      var closeBtn = document.getElementById('tq-close');
      if (closeBtn) closeBtn.addEventListener('click', closeQuiz);
      overlay.addEventListener('click', function (e) { if (e.target === overlay) closeQuiz(); });
    }

    /* ── NEWSLETTER POPUP ── */
    var nl = document.getElementById('nl-overlay');
    if (nl) {
      var KEY = 'hn_newsletter_seen';
      if (localStorage.getItem(KEY)) return;
      function hide() { nl.classList.remove('show'); setTimeout(function () { nl.style.display = 'none'; }, 420); localStorage.setItem(KEY, '1'); }
      var c = document.getElementById('nl-close'); if (c) c.addEventListener('click', hide);
      var d = document.getElementById('nl-dismiss'); if (d) d.addEventListener('click', hide);
      nl.addEventListener('click', function (e) { if (e.target === nl) hide(); });
      var form = document.getElementById('nl-popup-form');
      if (form) form.addEventListener('submit', function () {
        // Allows the real Shopify customer form to post; show confirmation optimistically
        localStorage.setItem(KEY, '1');
      });
      setTimeout(function () {
        nl.style.display = 'flex';
        requestAnimationFrame(function () { requestAnimationFrame(function () { nl.classList.add('show'); }); });
      }, 1800);
    }
  });
})();
